import RoomString from '@/components/partials/RoomString'
import RoomImage from '@/components/partials/RoomImage'
import RoomHelp from '@/components/partials/RoomHelp'
import RoomFile from '@/components/partials/RoomFile'

export default {
  data () {
  },
  components: { RoomString, RoomImage, RoomHelp, RoomFile },
  computed: {
    roomData: function () {
      return this.$store.state.data.Room
    },
    helpData: function () {
      return this.$store.state.data.Room.help || {}
    }
  },
  methods: {
    deleteMedia: function (key, data) {
      this.$store.dispatch('removeMediaFromRoom', { content: data, key })
        .then((response) => {
          console.log(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateMedia: function (key, data) {
      return null
    },
    log: function (data) {
      console.log('log function')
      console.log(JSON.stringify(data, null, 2))
    }
  }
}
